import React from 'react';
import { RiskMapDataType2 } from '../types';
import RiskTile from './RiskTile';

type RiskTableRowProps = {
  threeToFive: RiskMapDataType2[];
  sixToTen: RiskMapDataType2[];
  elevenToFifteen: RiskMapDataType2[];
  sixteenToTwenty: RiskMapDataType2[];
  twentyOnePlus: RiskMapDataType2[];
  riskCategory: number;
};

const RiskTableRow: React.FC<RiskTableRowProps> = ({
  threeToFive,
  sixToTen,
  elevenToFifteen,
  sixteenToTwenty,
  twentyOnePlus,
  riskCategory
}) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '4px',
        overflow: 'hidden'
      }}
    >
      <div className="titleColumn">{`Risk Rating ${riskCategory}`}</div>
      <RiskTile riskRatedFunds={threeToFive} timeHorizon="3-5yrs" />
      <RiskTile riskRatedFunds={sixToTen} timeHorizon="6-10yrs" />
      <RiskTile riskRatedFunds={elevenToFifteen} timeHorizon="11-15yrs" />
      <RiskTile riskRatedFunds={sixteenToTwenty} timeHorizon="16-20yrs" />
      <RiskTile riskRatedFunds={twentyOnePlus} timeHorizon="21+yrs" />
    </div>
  );
};

export default RiskTableRow;
